import {useDispatch} from 'ui/store';
import {updateBudget as updateBudgetAction} from 'store/Budget';
import {updateHistory as updateHistoryAction} from 'store/History';
import {updateDailyBudget as updateDailyBudgetAction} from 'store/DailyBudget';
import {updateMoneyBox as updateMoneyBoxAction} from 'store/MoneyBox';

export function useRefreshCore(): (newSettings: CoreState) => void {
  const updateBudget = useDispatch(updateBudgetAction);
  const updateHistory = useDispatch(updateHistoryAction);
  const updateDailyBudget = useDispatch(updateDailyBudgetAction);
  const updateMoneyBox = useDispatch(updateMoneyBoxAction);

  return function refreshStore(newSettings: CoreState): void {
    updateBudget(newSettings.budget);
    updateHistory(newSettings.history);
    updateDailyBudget(newSettings.dailyBudget);
    updateMoneyBox(newSettings.moneyBox);
  };
}
